/**
 * @owner @Appboy/messaging-experience
 */

import { canvasStepRemoteLookupValidators } from "@schemas/remoteLookup/canvasStepRemoteLookupSchema";
import type {
  CanvasStepRemoteLookupId,
  CanvasStepRemoteLookupItem,
  CanvasStepRemoteLookupFilters,
} from "@schemas/types";
import type { z } from "zod";

import type { RemoteLookupProvider } from "./types";

export const canvasStepProvider: RemoteLookupProvider<
  CanvasStepRemoteLookupId,
  CanvasStepRemoteLookupItem,
  CanvasStepRemoteLookupFilters
> = {
  // Identity is the composite (canvas_id, step_id) so a step is always resolved
  // within its parent Canvas.
  mapItemToId: (item) => ({ canvas_id: item.canvas_id, step_id: item.step_id }),
  mapIdToString: (id) => `${id.canvas_id}::${id.step_id}`,
  // The backend searches steps on name; match on name only.
  mapItemToSearchString: (item) => item.name ?? "",
  validators: {
    ...canvasStepRemoteLookupValidators,
    // non-strict typescript issue
    item: canvasStepRemoteLookupValidators.item as z.ZodType<CanvasStepRemoteLookupItem>,
  },
};
